<script>
	// From Lucide
	import { Map } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Map class={iconClass} />
